import getO365ShellShim from './getO365ShellShim';
import { safeRequestAnimationFrame } from 'owa-performance';

export default function setShellButtonCustomTooltip(buttonId: string, tooltip: string) {
    // Call after RAF to prevent changing state during render
    safeRequestAnimationFrame(() =>
        getO365ShellShim().Extensibility.SetCustomHeaderButtonBadgeLabel(buttonId, tooltip)
    );
}
